import { Star } from "lucide-react";

/**
 * O medidor circular do ICena (0–10). Era local do `GlobalDashboardPage`;
 * extraído quando o Relatório CENA precisou do mesmo indicador — duas
 * cópias divergiriam na primeira mudança de escala.
 *
 * O `conic`/`stroke` aqui é técnico, não decorativo: são dois círculos
 * SVG com `stroke-dasharray`, cor sólida, sem mistura — dentro do que o
 * sistema de design permite.
 */
export function CenaGauge({ value }: { value: number | null }) {
  const size = 52;
  const strokeWidth = 5;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const fraction = Math.max(0, Math.min(1, (value ?? 0) / 10));
  return (
    <div className="dashboard-kpi-gauge-wrap" aria-hidden="true">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="dashboard-kpi-gauge">
        <circle cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidth} className="dashboard-kpi-gauge-track"/>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          className="dashboard-kpi-gauge-value"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - fraction)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <Star size={18} className="dashboard-kpi-gauge-icon"/>
    </div>
  );
}
